import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../assets/css/Footer.css";

function Footer() {
  return (
    <>
      {/* Footer Start */}

      <div className="ooter_backGroundImage">
        <div className="cta-dark text-center px-4 py-5">
          <h2
            className="fw-semibold text-white mb-3"
            style={{ fontSize: "clamp(18px,3vw,22px)" }}
          >
            Ready to Evolve, Innovate & Succeed?
          </h2>
          <p
            className="mb-4 mx-auto"
            style={{
              fontSize: 13,
              color: "#aaa",
              maxWidth: 500,
              lineHeight: 1.7,
            }}
          >
            Join 500+ businesses and 5000+ professionals who have already
            transformed their operations and careers with Skimitar Hindusthan.
          </p>
          <div className="d-flex gap-2 justify-content-center flex-wrap mb-3">
            <button
              className="btn btn-red px-4 py-2 fw-semibold"
              style={{ borderRadius: 8, fontSize: 13 }}
            >
              Get Free Consultation →
            </button>
            <button
              className="btn btn-outline-light-custom px-4 py-2"
              style={{ borderRadius: 8, fontSize: 13 }}
            >
              📞 (+91) 8428010909
            </button>
          </div>
          <p style={{ fontSize: 11, color: "#ada8a8" }}>
            Support@skimitarhindusthan.com · Erode, Tamil Nadu · Pan-India
            Service
          </p>

          <div className="d-flex flex-column justify-content-center align-items-center text-center">
            <hr className="text-white w-75" />

            <span style={{ fontSize: 10, color: "#ada8a8" }}>
              © Copyright 2026. All Rights Reserved by Skimitar Hindusthan Pvt
              Ltd
            </span>
          </div>
        </div>
      </div>
    </>
  );
}

export default Footer;

// import React from "react";

// const Footer = () => {
//   return (
//     <>
//       <div className="cta-dark text-center px-4 py-5">
//         <h2
//           className="fw-semibold text-white mb-3"
//           style={{ fontSize: "clamp(18px,3vw,22px)" }}
//         >
//           Ready to Evolve, Innovate & Succeed?
//         </h2>
//         <p
//           className="mb-4 mx-auto"
//           style={{
//             fontSize: 13,
//             color: "#aaa",
//             maxWidth: 500,
//             lineHeight: 1.7,
//           }}
//         >
//           Join 500+ businesses and 5000+ professionals who have already
//           transformed their operations and careers with Skimitar Hindusthan.
//         </p>
//         <div className="d-flex gap-2 justify-content-center flex-wrap mb-3">
//           <button
//             className="btn btn-red px-4 py-2 fw-semibold"
//             style={{ borderRadius: 8, fontSize: 13 }}
//           >
//             Get Free Consultation →
//           </button>
//           <button
//             className="btn btn-outline-light-custom px-4 py-2"
//             style={{ borderRadius: 8, fontSize: 13 }}
//           >
//             📞 (+91) 8428010909
//           </button>
//         </div>
//         <p style={{ fontSize: 11, color: "#555" }}>
//           Support@skimitarhindusthan.com · Erode, Tamil Nadu · Pan-India Service
//         </p>
//       </div>
//     </>
//   );
// };

// export default Footer;
